import FilterDepartmentTree from './FilterDepartmentTree'

export default FilterDepartmentTree